export default __webpack_public_path__ + "static/media/08.e6efd91b.jpg";